import Loadable from '../../../components/loadable';

const ManageMembershipCancellationReasonsModal = Loadable({
  loader: () =>
    import('../../../pages/contacts/memberships/manage_membership_cancellation_reasons_modal'),
  type: 'modal',
});

angular
  .module('gym')
  .value('ManageMembershipCancellationReasonsModal', ManageMembershipCancellationReasonsModal);
